import React, { useState } from 'react';
import AddInventoryForm from '../components/DashboardComponents/AddInventoryForm'; // Assuming this component is already styled
import { FaHome, FaInfo } from 'react-icons/fa'; // Ensure react-icons is installed
import { useLanguage } from '../contexts/LanguageContext';
import AddInventoryFormFilament from '../components/DashboardComponents/AddInventoryFormFilament';

const AddInventory = () => {
    const { t } = useLanguage();
    const [activeTab, setActiveTab] = useState('spun');
    const [selectedOption, setSelectedOption] = useState("$ / kg");

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };

    const tabs = [
        { id: 'spun', title: 'Spun', icon: FaHome, content: (
            <AddInventoryForm selectedOption={selectedOption}/>
        )},
        { id: 'filament', title: 'Filament', icon: FaInfo, content: (
          <>
          <AddInventoryFormFilament selectedOption={selectedOption}/>
          </>
        )},
    ];

    return (
        <section className='dashboard-page'>
            <div className="dashboard-container">
            <div className="dasboard-head mb-4">
                <h2>{t('addInventory.heading', 'Add New Inventory')}</h2>
                </div>
                <div className="tabs-card">
                    {/* Tab Navigation */}
                    <div className="tab-navigation">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                {/*{tab.icon && <tab.icon className="tab-icon" />}*/}
                                <span className="tab-title">{tab.title}</span>
                            </button>
                        ))}
                        <div className='price-select-wrap ml-auto' style={{maxWidth: "250px"}}>
                        <select className='form-select w-100' value={selectedOption} onChange={handleChange}>
                            <option value="$ / kg">$/kg</option>
                            <option value="Rp Jt/bale inc ppn">Rp Jt/bale inc ppn</option>
                        </select>
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content-container">
                        {tabs.map((tab) => (
                            <div
                                key={tab.id}
                                className={`tab-pane ${activeTab === tab.id ? 'active' : ''}`}
                            >
                                {tab.content}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AddInventory;